import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {IWorkflowCollectionState} from '@features/workflow/store/workflow.reducer';
import {Store} from '@ngrx/store';
import {
  ArchiveCaseCommand,
  CreateArrangementFromExistingCaseCommand, SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand,
  SyncParticipantsCommand,
  SyncProjectEntityToCompanyCommand
} from '@features/dac6-reporter/commands/dac6-reporter.command';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {takeUntil} from 'rxjs/operators';
import {BasketProvider} from '@shared/models/basket-provider';

@Injectable({
  providedIn: 'root',
})
export class ArchiveCasesCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(
    private router: Router,
    private store: Store<IWorkflowCollectionState>,
    private fuseSplashScreenService: FuseSplashScreenService,
    private snackBarService: SnackBarService,
    private dialogService: DialogService,
    protected commandService: CommandService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    const input = {
      ['SELECTION_KEY']: command.fieldValues['SelectionKey'],
      ['ITEMS_SOURCE_TYPE']: command.fieldValues['SourceType']
    };
    const filterId = command.fieldValues['SelectionKey'];
    const basketSourceType = BasketProvider.getBasketMappedSourceType(command.fieldValues['SourceType']);
    const preCommand = new SaveSelectedCaseModelsInLeftSideOfTheTransferboxCommand(command.fieldValues['SelectionKey'], filterId, basketSourceType);
    this.commandService.executeCommand(preCommand).subscribe(prestate => {
      if (prestate) {
        const dialogModel = DialogModel.create('Select', 'EntitySelectorDialogComponent', {
          filterId: command.fieldValues['SelectionKey'],
          filterTemplateId: command.fieldValues['FilterTemplateId'],
          apiKey: command.api,
          input: input
        });
        dialogModel.minWidth = '1200px';
        dialogModel.maxWidth = '1200px';
        dialogModel.okCaption = 'Next';
        dialogModel.isFullscreen = true;
        this.dialogService.showOkCancelDialog(dialogModel)
          .pipe(takeUntil(this.unSubscribe$))
          .subscribe(actionState => {
            if (actionState && actionState.action === 'OK') {
              this.showArchiveDialog(command, handler);
            }
          });
      }
    });
    return true;
  }
  showArchiveDialog(command: PlatformCommand, handler: IPlatformToolHandler) {
    const dialogModel = DialogModel.create('Archive Case(s)',
      'ArchiveDialogComponent',
      {}, '500px', '490px', false);
    dialogModel.okCaption = 'Archive';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unSubscribe$)).subscribe(data => {
      if (data.action === 'OK') {
        console.log('Clicked Okay');
        console.log(data.data.input['comment']);
        const archiveCaseCommand = new ArchiveCaseCommand(command.fieldValues['SelectionKey'], command.fieldValues['SelectionKey'], command.fieldValues['SourceType'], data.data.input['comment']);
        this.fuseSplashScreenService.show();
        this.commandService.executeCommand(archiveCaseCommand).subscribe(state => {
          handler.invalidateSubject.invalidate();
          this.fuseSplashScreenService.hide();
        });
      }
    });
  }
}
